import React from 'react'
import { Icon } from '@chakra-ui/icons'
import { Button } from '@chakra-ui/react'
import { FaUserPlus } from 'react-icons/fa6'

import {
    ClinicFieldsFragment,
    ClientPreviewFieldsFragment,
    ClientFormFieldsFragment,
    useAssignClientFormToClientMutation,
    namedOperations,
} from '~graphql/generated/graphql'
import { useToastFeedback } from '~utils/hooks/use-toast-feedback'
import ClientsPatientsSearch from '~components/client-patient-search'
import { SearchModalType } from '~components/client-patient-search/types'

interface Props {
    clientForm: ClientFormFieldsFragment
    isSmall?: boolean
}

export default function FormSubmittedAssignClientAction({
    clientForm,
    isSmall,
}: Props) {
    const { onCompleted, onError } = useToastFeedback(
        'Successfully assigned client form to client',
        'Error assigning client form to client',
    )

    const [assignToClient, { loading: assignToClientLoading }] =
        useAssignClientFormToClientMutation({
            refetchQueries: [
                namedOperations.Query.countActionItems,
                namedOperations.Query.queryActionItems,
                namedOperations.Query.queryClientForms,
                namedOperations.Query.clientForm,
            ],
            onCompleted: () => {
                onCompleted()
            },
            onError: () => onError(),
        })

    async function handleAssignClient(
        client: ClientPreviewFieldsFragment | null | undefined,
        clinic: ClinicFieldsFragment | null | undefined,
    ) {
        if (!client || !clinic) return

        await assignToClient({
            variables: {
                id: clientForm.id,
                clientId: client.id,
            },
        })
    }

    return (
        <ClientsPatientsSearch
            onSelect={({ client, clinic }) =>
                handleAssignClient(client, clinic)
            }
            type={SearchModalType.Client}
            customTrigger={onClick => (
                <Button
                    size={isSmall ? 'xs' : 'sm'}
                    shadow="sm"
                    colorScheme="brand"
                    leftIcon={isSmall ? undefined : <Icon as={FaUserPlus} />}
                    isLoading={assignToClientLoading}
                    onClick={onClick}
                >
                    Assign client
                </Button>
            )}
        />
    )
}
